export function customMask(value: string, pattern: string): string {
  const numbers = value.replace(/\D/g, '');
  let result = '';
  let numberIndex = 0;

  for (let i = 0; i < pattern.length; i++) {
    const patternChar = pattern[i];

    if (patternChar === '9') {
      if (numberIndex < numbers.length) {
        result += numbers[numberIndex];
        numberIndex++;
      } else {
        break;
      }
    } else {
      result += patternChar;
    }
  }

  return result;
}
